import { render, staticRenderFns } from "./CustomerUpdate.vue?vue&type=template&id=f45f6dc0&scoped=true&"
import script from "./CustomerUpdate.vue?vue&type=script&lang=js&"
export * from "./CustomerUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CustomerUpdate.vue?vue&type=style&index=0&id=f45f6dc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45f6dc0",
  null
  
)

export default component.exports